import React from 'react';
import readableFileSize from 'filesize';
import DetailItem from './DetailItem';
import { deviationHasFileSizeMetadata } from './helpers';
export const OriginalSize = ({ deviation })=>{
    if (!deviationHasFileSizeMetadata(deviation)) {
        return null;
    }
    const { filesize, width, height } = deviation.extended.originalFile;
    return /*#__PURE__*/ React.createElement(DetailItem, {
        name: "itemsize",
        value: `${width}x${height}px ${readableFileSize(filesize)}`
    });
};
OriginalSize.displayName = 'OriginalSize';
export default OriginalSize;
